import { getRandomInt32 } from '../../common/helpers/getRandom';

export function getId(prefix?: string): string {
    return `${prefix ? prefix : 'myId'}${getRandomInt32()}`;
}